import React, { FunctionComponent, memo, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { PlatformHelper } from '@sport1/react-elements'
import { IconProps } from '../NavigationBar/Icon/IconProps'
import NavigationBarButtonWithBackground from '../../BaseComponents/Button/NavigationBar/WithBackground'
import GalleryPageCounter from '../../Gallery/PageCounter'

export type NavigationBarIconProps = IconProps & {
    onPress: () => void
}
export type NavigationBarProps = {
    /**
     * icon on the left side
     */
    leftIcon: NavigationBarIconProps
    /**
     * will render a share-icon when set and has a onPress callback
     * @TJS-Type: function
     */
    onShare?: () => void
    /**
     * will render a counter when set
     */
    counterProps?: { currentPage: number; maxPages: number }
    marginLeft?: number
}

const GalleryNavigationBar: FunctionComponent<NavigationBarProps> = ({
    leftIcon,
    onShare,
    counterProps,
    marginLeft,
}): ReactElement => {
    return (
        <Grid pointerEvents="box-none" horizontal noExpand minHeight={44} centerVertical>
            <NavigationBarButtonWithBackground
                color={leftIcon?.color}
                onPress={leftIcon.onPress}
                name={leftIcon.name}
                marginX={marginLeft}
            />

            <Grid alignRight horizontal paddingRight={counterProps ? 5 : 0}>
                {onShare ? (
                    <NavigationBarButtonWithBackground
                        color="WHITE"
                        name={PlatformHelper.onAndroid ? 'share-android' : 'share-ios'}
                        onPress={onShare}
                    />
                ) : null}
                {counterProps ? (
                    <GalleryPageCounter
                        currentPage={counterProps.currentPage}
                        maxPages={counterProps.maxPages}
                    />
                ) : null}
            </Grid>
        </Grid>
    )
}

export default memo(GalleryNavigationBar)
